import { Name } from 'libs/shared/model/src/lib/types/name.type';

export function transformNameToDisplayName(name: Name, externalLabel?: string): string {
  if (!name) {
    return '';
  }

  let displayName = `${name.firstName ?? ''} ${name.lastName ?? ''}`.trim();

  if (name.isExternal && externalLabel) {
    displayName = displayName ? `${displayName} [${externalLabel}]` : `[${externalLabel}]`;
  }

  if (name.isTreetopUser) {
    displayName = displayName ? `[Treetop] ${displayName} ` : `[Treetop]`;
  }

  return displayName;
}
